import React from 'react'
import { Button, Switch } from 'antd'
import { FileDown } from 'lucide-react'
import { useFFEStore } from '../../store/ffeStore'

export interface ExportOptions {
  showSupplierDetails: boolean
  showClientPrices: boolean
  showTotalValue: boolean
}

interface Props {
  onExport: () => void
}

export const ExportOptions: React.FC<Props> = ({ onExport }) => {
  const updateSettings = useFFEStore((state) => state.updateSettings)
  const settings = useFFEStore((state) => state.document.settings)

  return (
    <div className="min-w-[300px] flex flex-col gap-4">
        <div className="gap-2 flex align-items-center">
          <Switch
            value={settings.showSupplierDetails}
            onChange={(value) =>
              updateSettings({
                ...settings,
                showSupplierDetails: value
              })
            }
          ></Switch>
          <span>Show supplier details</span>
        </div>

        <div className="gap-2 flex align-items-center">
          <Switch
            value={!settings.hideMaterialNames}
            onChange={(value) =>
              updateSettings({
                ...settings,
                hideMaterialNames: !value
              })
            }
          ></Switch>
          <span>Show finish names</span>
        </div>

        <div className="gap-2 flex align-items-center">
          <Switch
            value={settings.showLeadTimes}
            onChange={(value) =>
              updateSettings({
                ...settings,
                showLeadTimes: value
              })
            }
          ></Switch>
          <span>Show lead times</span>
        </div>

        <div className="gap-2 flex align-items-center">
          <Switch
            value={settings.showClientPrices}
            onChange={(value) =>
              updateSettings({
                ...settings,
                showClientPrices: value
              })
            }
          ></Switch>
          <span>Show client prices</span>
        </div>

        <div className="gap-2 flex align-items-center">
          <Switch
            value={settings.showTotalValue}
            onChange={(value) =>
              updateSettings({
                ...settings,
                showTotalValue: value
              })
            }
          ></Switch>
          <span>Show total schedule value</span>
        </div>

      <Button
        type="primary"
        icon={<FileDown className="h-4 w-4" />}
        onClick={onExport}
        block
      >
        Export PDF
      </Button>
    </div>
  )
}
